import { Features } from "../components/RequireFeature";
import { Subscriptions } from "../components/RequireSubscription";
import { userRoles } from "../components/RoleProtected";

export const InitialMenu = [
    {
        label: 'Home',
        icon: 'home',
        path: '/'
    },
    {
        label: 'Customers',
        icon: 'group',
        route: '/customers',
        role: [userRoles.viewCustomers, userRoles.viewAuditReports, userRoles.viewUsageReports],
        subscription: [Subscriptions.Silver, Subscriptions.Gold],
        items: [
            {
                label: 'Customer List',
                path: '/customers',
                role: userRoles.viewCustomers,
            }, {
                label: 'Search by Media',
                path: '/media/mediaLookup',
                role: userRoles.viewCustomers,
            }, {
                label: 'Visitor Intelligence',
                path: '/visitors',
                role: userRoles.viewCustomers,
                feature: Features.PlateReads,
                subscription: Subscriptions.Gold
            }, {
                label: 'License Plate Reads',
                path: '/media/LicensePlateReads',
                role: [userRoles.viewAuditReports, userRoles.viewUsageReports],
                feature: Features.PlateReads,
                subscription: Subscriptions.Gold
            }, {
                label: 'Push Notifications',
                path: '/mobile/pushNotifications',
                role: userRoles.notifications,
            }
        ]
    },
    {
        label: 'Reports',
        icon: 'clipboard',
        route: '/reporting',
        role: [userRoles.viewFinancialReports, userRoles.viewAuditReports, userRoles.viewUsageReports],
        items: [
            {
                label: 'Sales',
                path: '/reporting/Sales',
                role: [userRoles.viewFinancialReports, userRoles.viewAuditReports, userRoles.viewUsageReports],
            }, {
                label: 'Mobile App',
                path: '/reporting/MobileApp',
                role: [userRoles.viewFinancialReports, userRoles.viewAuditReports],
                subscription: [Subscriptions.Silver, Subscriptions.Gold]
            }, {
                label: 'Codes',
                path: '/reporting/Codes',
                role: [userRoles.viewAuditReports],
            }, {
                label: 'Subscriptions',
                path: '/reporting/Subscriptions',
                role: [userRoles.viewAuditReports, userRoles.viewUsageReports],
                subscription: Subscriptions.Gold
            },
        ]
    },
    {
        label: 'Products',
        icon: 'coins',
        route: '/products',
        role: [userRoles.viewProducts, userRoles.viewCustomers, userRoles.fulfillment],
        items: [
            {
                label: 'Kiosk Items',
                path: '/products/kioskItems',
                role: userRoles.viewProducts,
            }, {
                label: 'Wash Clubs',
                role: userRoles.viewProducts,
                path: '/washClub',
                subscription: Subscriptions.Gold
            }, {
                label: 'ExpressPass',
                role: userRoles.viewCustomers,
                path: '/expressPass',
                subscription: Subscriptions.Gold
            }, {
                label: 'Mobile App',
                path: '/products/mobile',
                role: userRoles.viewProducts,
                subscription: [Subscriptions.Silver, Subscriptions.Gold]
            }, {
                label: 'Fulfillment',
                role: userRoles.fulfillment,
                path: '/fulfillment',
                subscription: [Subscriptions.Silver, Subscriptions.Gold]
            }, {
                label: 'Kiosk Bundles',
                path: '/kioskBundles',
                role: userRoles.viewProducts,
                subscription: [Subscriptions.Silver, Subscriptions.Gold]
            }, {
                label: 'App Credit',
                path: '/products/appCredit',
                role: userRoles.viewProducts,
                feature: Features.AppCredit,
                subscription: [Subscriptions.Silver, Subscriptions.Gold]
            }
        ]
    },
    {
        label: 'Awards',
        icon: 'award',
        route: '/awards',
        role: [userRoles.viewProducts, userRoles.accountConfiguration],
        subscription: [Subscriptions.Silver, Subscriptions.Gold],
        items: [
            {
                label: 'License Plate',
                path: '/awards',
                role: userRoles.viewProducts,
                feature: Features.PlateReads,
                subscription: Subscriptions.Gold
            }, {
                label: 'Mobile App',
                role: userRoles.accountConfiguration,
                items: [
                    {
                        label: 'Deals',
                        path: '/mobile/deals',
                    },
                    {
                        label: 'Promo Codes',
                        path: '/mobile/promoCodes',
                    }, {
                        label: 'Loyalty Points',
                        path: '/mobile/loyaltyPoints',
                        role: userRoles.accountConfiguration,
                        excludeFeature: Features.AwardEnhancement,
                    }, {
                        label: 'Loyalty Point Awards',
                        path: '/mobile/loyaltyPointAwards',
                        role: userRoles.accountConfiguration,
                        feature: Features.AwardEnhancement,
                    }, {
                        label: 'Referral Program',
                        path: '/mobile/referralProgram',
                        role: userRoles.accountConfiguration,
                    }, {
                        label: 'Birthday Club',
                        path: '/mobile/birthdayClub',
                        role: userRoles.accountConfiguration,
                    }
                ]
            }
        ]
    },
    {
        label: 'Codes',
        icon: 'QRcode',
        route: '/codes',
        items: [
            {
                label: 'Single Use Codes',
                path: '/SingleUseCodes',
                role: userRoles.issueRewash,
            }, {
                label: 'Receipt Codes',
                path: '/ReceiptCodes',
                role: userRoles.viewProducts,
                subscription: [Subscriptions.Silver, Subscriptions.Gold]
            }
        ]
    },
    {
        label: 'Settings',
        icon: 'cog',
        route: '/settings',
        role: [userRoles.viewProducts, userRoles.viewCustomers, userRoles.accountConfiguration, userRoles.admin],
        items: [
                        {
                label: 'Organization Settings',
                path: '/Settings',
                role: [userRoles.accountConfiguration, userRoles.admin]
            },
                    {
                        label: 'Mobile App',
                        role: userRoles.accountConfiguration,
                        items: [
                            {
                                label: 'AirPAY',
                                path: '/mobile/airPay',
                                role: userRoles.accountConfiguration,
                            },
                            {
                                label: 'Gift Email Details',
                                path: '/mobile/giftEmailDetails',
                                role: userRoles.accountConfiguration,
                            },
                            {
                                label: 'Locations',
                                path: '/mobile/locations',
                                role: userRoles.accountConfiguration,
                            },
                            {
                                label: 'Settings',
                                path: '/mobile/settings',
                                role: userRoles.accountConfiguration,
                            },
                            {
                                label: 'Survey Results',
                                path: '/mobile/surveys',
                            }
                        ]
                    }

        ]
    },
    {
        label: 'Locations',
        icon: 'mapLocation',
        path: '/locations',
    },
    {
        label: 'Account',
        icon: 'user',
        path: '/myAccount',
        // items: [
        //     {
        //         label: 'User Details',
        //         path: '/myAccount#UserDetails',
        //     }, {
        //         label: 'Terms of Service',
        //         path: '/myAccount#TermsOfService',
        //     }
        // ]
    },
    {
        label: 'Support',
        icon: 'questionMark',
        route: '/hamilton',
        items: [
            {
                label: 'Info',
                path: '/hamilton#Info',
            }, {
                label: 'Updates',
                path: '/hamilton#Updates',
            }, {
                label: 'Feedback',
                path: '/hamilton#Feedback',
            }
        ]
    }
]

export const findMenuLabelByPath = (targetPath, menu = InitialMenu) => {
    for (const item of menu) {
        if (item.path === targetPath) return item.label;
        if (item.items) {
            const found = findMenuLabelByPath(targetPath, item.items);
            if (found) return found;
        }
    }
    return null;
}
